import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import "./CustomToolbar.css";

const CustomToolbar = ({ date, onNavigate }) => {
    const georgianMonths = ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი'];

    const handleMonthChange = (event) => {
        let newDate = new Date(date.getFullYear(), event.target.value, 1);
        onNavigate('current', newDate);
    };

    const handleYearChange = (event) => {
        let newDate = new Date(event.target.value, date.getMonth(), 1);
        onNavigate('current', newDate);
    };

    const navigate = (action) => {
        onNavigate(action);
    };

    const years = Array.from({ length: 20 }, (_, i) => new Date().getFullYear() + i);

    return (
        <div className={"custom-toolbar"}>
            <div className="toolbar-navigation-buttons">
                <Button variant="contained" color="primary" onClick={() => navigate('PREV')} style={{ marginRight: 10, width: "80px" }}>წინა</Button>
                <Button variant="contained" color="primary" onClick={() => navigate('TODAY')} style={{ marginRight: 10, width: "80px" }}>დღეს</Button>
                <Button variant="contained" color="primary" onClick={() => navigate('NEXT')} style={{ marginRight: 10, width: "80px" }}>შემდეგი</Button>
            </div>
            <div>

            </div>
            <div className="toolbar-select-controls">
                <FormControl variant="outlined" style={{ marginRight: 10 }}>
                    <InputLabel id="month-select-label">თვე</InputLabel>
                    <Select
                        labelId="month-select-label"
                        label="თვე"
                        value={date.getMonth()}
                        onChange={handleMonthChange}
                    >
                        {georgianMonths.map((month, index) => (
                            <MenuItem key={index} value={index}>{month}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl variant="outlined">
                    <InputLabel id="year-select-label">წელი</InputLabel>
                    <Select
                        labelId="year-select-label"
                        label="წელი"
                        value={date.getFullYear()}
                        onChange={handleYearChange}
                    >
                        {years.map(year => (
                            <MenuItem key={year} value={year}>{year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

            </div>
        </div>
    );
};

export default CustomToolbar;
